/* RECURA bricks: hero slider, row arrows, quick add, silent reels, collection sort.
 * Plain script, no dependencies, everything keyed on data-rb-* so the sections stay markup only. */
(function () {
  'use strict';
  var rtl = document.documentElement.dir === 'rtl';

  /* ---------- hero: scroll-snap track, dots, auto advance that stops for good on the first touch ---------- */
  function initHero(root) {
    var track = root.querySelector('[data-rb-hero-track]');
    var dots = root.querySelectorAll('[data-rb-hero-dots] button');
    if (!track || dots.length < 2) return;
    var slides = track.children, idx = 0, timer = null, stopped = false;
    function go(i, smooth) {
      idx = (i + slides.length) % slides.length;
      var w = track.clientWidth;
      track.scrollTo({ left: (rtl ? -1 : 1) * idx * w, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function paint() {
      var w = track.clientWidth || 1;
      var i = Math.round(Math.abs(track.scrollLeft) / w);
      idx = i;
      dots.forEach(function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    function stop() { stopped = true; if (timer) clearInterval(timer); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { stop(); go(k); }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) { root.addEventListener(ev, stop, { passive: true, once: true }); });
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      timer = setInterval(function () { if (!stopped && !document.hidden) go(idx + 1); }, 6000);
    }
  }

  /* ---------- rows: arrows scroll one card; greyed at the ends; hidden when nothing to scroll ---------- */
  function initArrows(sec) {
    var sc = sec.querySelector('[data-rb-scroller]');
    var box = sec.querySelector('[data-rb-arrows]');
    if (!sc || !box) return;
    var prev = box.querySelector('[data-rb-dir="-1"]'), next = box.querySelector('[data-rb-dir="1"]');
    function step() { var c = sc.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : 300; }
    function state() {
      var max = sc.scrollWidth - sc.clientWidth;
      box.hidden = max < 8;
      var pos = Math.abs(sc.scrollLeft);
      prev.disabled = pos < 4;
      next.disabled = pos > max - 4;
    }
    [prev, next].forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = Number(b.getAttribute('data-rb-dir'));
        sc.scrollBy({ left: dir * step() * (rtl ? -1 : 1), behavior: 'smooth' });
      });
    });
    sc.addEventListener('scroll', function () { window.requestAnimationFrame(state); }, { passive: true });
    window.addEventListener('resize', state);
    state();
  }

  /* ---------- quick add: same path the buy box uses, then the theme's own drawer opens ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rb-add]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    var id = Number(btn.getAttribute('data-rb-add'));
    btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'rb-quick-add', data: { source: 'product-form', itemCount: cart.item_count, variantId: String(id) } }
        }));
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else window.location.href = '/cart';
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1800);
      })
      .catch(function () { window.location.href = '/cart/add?id=' + id + '&quantity=1'; })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });

  /* ---------- reels: load and play only while on screen; one clip with sound at a time ---------- */
  function initReels(sec) {
    var vids = sec.querySelectorAll('video[data-src]');
    function load(v) { if (!v.src) { v.src = v.getAttribute('data-src'); } }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { load(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.35 });
      vids.forEach(function (v) { io.observe(v); });
    }
    // safety net: a clip that never got a source (observer starved in a hidden tab) still gets one
    setTimeout(function () { vids.forEach(load); }, 6000);
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rb-snd]');
      if (!b) return;
      var v = b.parentElement.querySelector('video');
      var turnOn = v.muted;
      document.querySelectorAll('[data-rb-reels] video').forEach(function (o) { o.muted = true; });
      document.querySelectorAll('[data-rb-snd]').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); o.setAttribute('aria-label', 'הפעלת סאונד'); });
      if (turnOn) { load(v); v.muted = false; v.play(); b.setAttribute('aria-pressed', 'true'); b.setAttribute('aria-label', 'השתקה'); }
    });
  }

  /* ---------- collection sort ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-rb-sort]');
    if (!sel) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sel.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* ---------- the current category pill scrolls into view on the phone (no page jump: only the pill row moves) ---------- */
  function centerPill(nav) {
    var on = nav.querySelector('.is-on');
    if (!on) return;
    var ul = nav;
    var r = on.getBoundingClientRect(), b = ul.getBoundingClientRect();
    ul.scrollLeft += (r.left + r.width / 2) - (b.left + b.width / 2);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-rb-hero]').forEach(initHero);
    (scope || document).querySelectorAll('.rb-row, .rb-reels').forEach(initArrows);
    (scope || document).querySelectorAll('[data-rb-reels]').forEach(initReels);
    (scope || document).querySelectorAll('[data-rb-pills]').forEach(centerPill);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
